@if(isBrowser()) {
<app-header></app-header>
@switch (mediaService.media()) {
@case ('xs') {
<ng-container *ngTemplateOutlet="mobileversion"></ng-container>
}
@case ('sm') {
<ng-container *ngTemplateOutlet="mobileversion"></ng-container>
}
@case ('md') {
<ng-container *ngTemplateOutlet="mobileversion"></ng-container>
}
@default {
<ng-container *ngTemplateOutlet="desktopmode"></ng-container>
}
}

<footer></footer>
}


<ng-template #desktopmode>
    <div class="offerwrapper">
        <div class="offerbody">
            @if(loading()) {
            <div class="loading">
                <mat-spinner></mat-spinner>
            </div>
            } @else {
            @if(details().length > 0) {
            @for (detail of details(); track $index) {
            <!-- {{detail.showheading}} -->
            @if(detail.showheading === 'Yes') {
            <div class="bosysdetail-headerwrapper">
                <span class="bosysdetail-title">{{detail.heading}}</span>
            </div>
            }
            <div class="bosysdetail-wrp">
                @switch (detail.heading) {
                @case ('Bilder') {
                <ng-container *ngTemplateOutlet="bildertmp; context: {details: detail}"></ng-container>
                }

                @case ('Beschreibung') {
                <div [class.smallheight]="!detail.showmore">
                    <ng-container *ngTemplateOutlet="detailstmp; context: {details: detail}"></ng-container>
                </div>
                <div [class.expendable]="!detail.showmore" class="expendableg" #bosysshowmorebutton>

                    @if(detail.showmore) {
                    <button class="custombutton customunfilled"
                        (click)="detail.showmore = !detail.showmore; gotobutton(bosysshowmorebutton)">WENIGER
                        ANZEIGEN</button>
                    } @else {
                    <button class="custombutton customunfilled" (click)="detail.showmore = !detail.showmore;">MEHR
                        ANZEIGEN</button>
                    }
                </div>
                }

                @default {
                <ng-container *ngTemplateOutlet="detailstmp; context: {details: detail}"></ng-container>
                }
                }
            </div>

            }
            @if(myoffer().book_form === 1) {
            <clever-bosysbooking [offer]="myoffer()" [form]="form()" [person]="person()"></clever-bosysbooking>
            }
            } @else {
            <ng-container *ngTemplateOutlet="nooffer"></ng-container>
            }
            }
        </div>
    </div>
</ng-template>
<ng-template #mobileversion>
    <div class="offerwrapper">
        <div class="offerbodymobile">
            @if(loading()) {
            <div class="loading">
                <mat-spinner></mat-spinner>
            </div>
            } @else {
            @if(details().length > 0) {
            @for (detail of details(); track $index) {
            @if(detail.showheading === 'Yes') {
            <div class="bosysdetail-headerwrapper">
                <span class="bosysdetail-title">{{detail.heading}}</span>
            </div>
            }
            <div class="bosysdetail-wrp">
                @switch (detail.heading) {
                @case ('Bilder') {
                <ng-container *ngTemplateOutlet="bildertmp; context: {details: detail}"></ng-container>
                }
                @case ('Beschreibung') {
                <div [class.smallheight]="!detail.showmore">
                    <ng-container *ngTemplateOutlet="detailstmp; context: {details: detail}"></ng-container>
                </div>
                <div [class.expendable]="!detail.showmore" class="expendableg" #bosysshowmorebutton>

                    @if(detail.showmore) {
                    <button class="custombutton customunfilled"
                        (click)="detail.showmore = !detail.showmore; gotobutton(bosysshowmorebutton)">WENIGER
                        ANZEIGEN</button>
                    } @else {
                    <button class="custombutton customunfilled" (click)="detail.showmore = !detail.showmore">MEHR
                        ANZEIGEN</button>
                    }
                </div>
                }

                @default {
                <ng-container *ngTemplateOutlet="detailstmp; context: {details: detail}"></ng-container>
                }
                }
            </div>
            }
            @if(myoffer().book_form === 1) {
            <clever-bosysbooking [offer]="myoffer()" [form]="form()" [person]="person()"></clever-bosysbooking>
            }
            } @else {
            <ng-container *ngTemplateOutlet="nooffer"></ng-container>
            }
            }
        </div>
    </div>
</ng-template>


<ng-template #nooffer>
    <div>Kein Angebot gefunden</div>
</ng-template>

<ng-template #detailstmp let-details="details">
    @for (item of details.xinfos; track $index) {
    @switch (item.type) {
    @case ('text') {
    <div [innerHTML]="item.content" class="importance-{{item.importance}}"></div>
    }
    @case ('image') {
    <img class="imgwrp" [class.bosysdetail-tourimg]="details.heading === 'Übersicht'" loading="lazy"
        [src]="item.content" alt="image">
    }
    @case ('97') {
    <ng-container *ngTemplateOutlet="flighttmp; context: {flight: item}"></ng-container>
    }
    @case ('98') {
    <ng-container *ngTemplateOutlet="mapstmp; context: {coord: item}"></ng-container>
    }
    @case ('99') {
    <ng-container *ngTemplateOutlet="reviewtmp; context: {review: item}"></ng-container>
    }
    @case ('table') {
    <ng-container *ngTemplateOutlet="tabletmp; context: {table: item}"></ng-container>
    }
    @case ('stars') {
    @if(categoryAr().length > 0) {
    <div class="sunmesurement">
        @for (cat of categoryAr(); track $index) {
        @if(cat === 1) {
        <div class="sunfilled"></div>
        } @else {
        <div class="sununfilled"></div>
        }
        }
    </div>
    }

    }
    }
    }
</ng-template>

<ng-template #tabletmp let-table="table">
    <table class="bosystable">
        @for (tb of table.content;let k=$index; track $index) {
        @if(tb.header?.length > 0) {
        <thead>
            <tr>
                @for (hed of tb.header; track $index) {
                <th>{{hed}}</th>
                }
            </tr>
        </thead>
        } @else {
        <tbody>
            <tr [class.stripedtrEven]="k%2 !== 0" [class.stripedtrOdd]="k%2 === 0">
                @for (td of tb.data; track $index) {
                <td>{{td}}</td>
                }
            </tr>
        </tbody>
        }
        }
    </table>
</ng-template>
<ng-template #reviewtmp let-review="review">
    @if(review) {
    <div class="bosysreview-wrapper">
        <clever-bosysreview [review]="review"></clever-bosysreview>
    </div>
    }
</ng-template>
<ng-template #mapstmp let-coord="coord">
    @if(coord?.GeoLong?.length > 0) {
    <div class="bosysmap-wrapper">
        <clever-mapcomponent [longitude]="coord?.GeoLong" [latitude]="coord?.GeoLat"
            [name]="name()"></clever-mapcomponent>
    </div>
    }
</ng-template>

<ng-template #bildertmp let-details="details">
    <clever-bosysimagelist [objlist]="details.xinfos"></clever-bosysimagelist>
</ng-template>
<ng-template #flighttmp let-flight="flight">
    <div class="bosisflight">
        @for (flg of flight.content; track $index) {
        @if(flg.Type === 'H') {
        <div class="bosysflightglbwrapper">
            <span class="bosisflighttiutle">Ihre voraussichtlichen Hinflugzeiten</span>
            <div class="bosysflightwrapper">
                <div class="bosysflightdate">
                    <span>{{flg.DepDate}}</span>
                    <span>{{flg.DepTime}}</span>
                </div>
                <div>
                    <mat-icon>flight_takeoff</mat-icon>
                </div>
                <div>
                    <span>{{flg.From}}</span>
                </div>
            </div>
            <div class="bosysflightmiteldiv">
                <div class="bosysflightempty"></div>
                <div class="bosysflightcarrier">
                    {{flg.Carrier}} ({{flg.FlightNo}})
                </div>
            </div>
            <div class="bosysflightwrapper">
                <div class="bosysflightdate">
                    <span>{{flg.ArrDate}}</span>
                    <span>{{flg.ArrTime}}</span>
                </div>
                <div>
                    <mat-icon>flight_land</mat-icon>
                </div>
                <div>
                    <span>{{flg.To}}</span>
                </div>
            </div>
        </div>
        } @else {
        <div class="bosysflightglbwrapper">
            <span class="bosisflighttiutle">Ihre voraussichtlichen Rückflugzeiten</span>
            <div class="bosysflightwrapper">
                <div class="bosysflightdate">
                    <span>{{flg.DepDate}}</span>
                    <span>{{flg.DepTime}}</span>
                </div>
                <div>
                    <mat-icon>flight_takeoff</mat-icon>
                </div>
                <div>
                    <span>{{flg.From}}</span>
                </div>
            </div>
            <div class="bosysflightmiteldiv">
                <div class="bosysflightempty"></div>
                <div class="bosysflightcarrier">
                    {{flg.Carrier}} ({{flg.FlightNo}})
                </div>
            </div>
            <div class="bosysflightwrapper">
                <div class="bosysflightdate">
                    <span>{{flg.ArrDate}}</span>
                    <span>{{flg.ArrTime}}</span>
                </div>
                <div>
                    <mat-icon>flight_land</mat-icon>
                </div>
                <div>
                    <span>{{flg.To}}</span>
                </div>
            </div>
        </div>
        }
        }
    </div>
</ng-template>


<clever-bosyscontact [myoffice]="myoffice()" [offers]="offerslist()" [offerid]="offerid()" [currentrecid]="recid()"
    [person]="person()"></clever-bosyscontact>
@if(offerslist()) {
<clever-bosyshotellist [offers]="offerslist()" [offerid]="offerid()" [currentrecid]="recid()"></clever-bosyshotellist>
<clever-bosyshotel [offers]="offerslist()" [myoffer]="myoffer()" [offerid]="offerid()"
    [currentrecid]="recid()"></clever-bosyshotel>
}